import axios from 'axios';
import { ADMIN_API_BASE } from './api_admin';

const DT_BASE = `${ADMIN_API_BASE}/date-treats`;
const auth = (token) => ({ headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
const _err = (e) => { if (e.response) console.error('Admin date-treats error:', e.response.status, e.response.data); };

const qs = (p) => {
    const s = new URLSearchParams();
    Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.append(k, v); });
    return s.toString();
};

export const dtError = (e, fb = 'Не удалось выполнить операцию') => e?.response?.data?.error || fb;

export const APIAdminDateTreats = async (token, params = {}) => {
    try { const r = await axios.get(`${DT_BASE}/?${qs(params)}`, auth(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

export const APIAdminDateTreatRedeem = async (token, id, venueNote = '') => {
    try { const r = await axios.post(`${DT_BASE}/${id}/redeem/`, { venue_note: venueNote }, auth(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

export const APIAdminDateTreatCancel = async (token, id, reason = '') => {
    try { const r = await axios.post(`${DT_BASE}/${id}/cancel/`, { reason }, auth(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

export const APIAdminDateTreatSettings = async (token) => {
    try { const r = await axios.get(`${DT_BASE}/settings/`, auth(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

export const APIAdminDateTreatSettingsUpdate = async (token, values) => {
    try { const r = await axios.put(`${DT_BASE}/settings/update/`, { values }, auth(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};